import { prop, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { User } from "../../users/_types/user";
import { CaseNote } from "../../cases/_types/case-note";

export class TaskComment extends Resource {
    public override type = 'taskComments';

    @prop()
    public taskId!: string;

    @prop()
    @required()
    public description!: string;

    @prop()
    public date: Date = new Date();

    @prop()
    public createdByUser!: User;
}